export const Role = {
    Admin: 'ADMIN',
    Director: 'DIRECTOR',
    ManageSchedule: 'MANAGESCHEDULE',
    Floater: 'FLOATER',
    Super: 'SUPER',
    ManageTeacher: 'SCHEDULERTEACHER',
    ManageTeacherRate: 'SCHEDULERTEACHERRATE',
    ManageStudent: 'SCHEDULERSTUDENT',
}